export default function SuccessIcon({ small }: { small?: boolean }) {
  const size = {
    height: small ? '77px' : '154px',
    width: small ? '80px' : '160px',
  }
  return (
    <svg width={size.width} height={size.height} viewBox='0 0 160 154' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M127.106 23.3868H37.7376V31.2557H30.4307L29.8687 120.624H38.2996V128.493L127.106 127.931V121.186H135.537L134.975 31.2557H127.106V23.3868Z'
        fill='#391998'
      />
      <path
        d='M127.106 23.3868H37.7376V31.2557H30.4307L29.8687 120.624H38.2996V128.493L127.106 127.931V121.186H135.537L134.975 31.2557H127.106V23.3868Z'
        fill='url(#paint0_linear_698_4661)'
        fillOpacity='0.1'
      />
      <path d='M95.7141 54H101.301V59.5873H95.7141V54Z' fill='white' />
      <path d='M102 54H107.587V59.5873H102V54Z' fill='white' />
      <path d='M102 60.2857H107.587V65.873H102V60.2857Z' fill='white' />
      <path d='M95.7141 60.2857H101.301V65.873H95.7141V60.2857Z' fill='white' />
      <path d='M89.4284 60.2857H95.0157V65.873H89.4284V60.2857Z' fill='white' />
      <path d='M89.4284 66.5714H95.0157V72.1587H89.4284V66.5714Z' fill='white' />
      <path d='M95.7141 66.5714H101.301V72.1587H95.7141V66.5714Z' fill='white' />
      <path d='M83.1427 66.5714H88.73V72.1587H83.1427V66.5714Z' fill='white' />
      <path d='M83.1427 72.8571H88.73V78.4444H83.1427V72.8571Z' fill='white' />
      <path d='M89.4284 72.8571H95.0157V78.4444H89.4284V72.8571Z' fill='white' />
      <path d='M76.857 72.8571H82.4443V78.4444H76.857V72.8571Z' fill='white' />
      <path d='M76.857 79.1428H82.4443V84.7301H76.857V79.1428Z' fill='white' />
      <path d='M83.1427 79.1428H88.73V84.7301H83.1427V79.1428Z' fill='white' />
      <path d='M70.5713 79.1428H76.1586V84.7301H70.5713V79.1428Z' fill='white' />
      <path d='M64.2855 79.1428H69.8728V84.7301H64.2855V79.1428Z' fill='white' />
      <path d='M64.2855 72.8571H69.8728V78.4444H64.2855V72.8571Z' fill='white' />
      <path d='M57.9998 72.8571H63.5871V78.4444H57.9998V72.8571Z' fill='white' />
      <path d='M57.9998 66.5714H63.5871V72.1587H57.9998V66.5714Z' fill='white' />
      <path d='M64.2855 86.127H69.8728V91.7143H64.2855V86.127Z' fill='white' />
      <path d='M70.5713 86.127H76.1586V91.7143H70.5713V86.127Z' fill='white' />
      <path d='M76.857 86.127H82.4443V91.7143H76.857V86.127Z' fill='white' />
      <path d='M70.5713 92.4127H76.1586V98H70.5713V92.4127Z' fill='white' />
      <path
        d='M126.777 22.9365V30.9169H37.2195L38.4388 120.474H30.1259V30.9169H37.2195V22.9365H126.777Z'
        fill='#5E33DC'
      />
      <path
        d='M127.664 31.8035H134.757V120.474H126.777V128.454H38.1062V121.361L126.777 120.474L127.664 31.8035Z'
        fill='#291170'
      />
      <path d='M53 38H45V46H53V38Z' fill='#FBFBFB' />
      <path d='M121 38H113V46H121V38Z' fill='#FBFBFB' />
      <path d='M121 106H113V114H121V106Z' fill='#FBFBFB' />
      <path d='M53 106H45V114H53V106Z' fill='#FBFBFB' />
      <path d='M135.312 120.984H127.219V129.078H135.312V120.984Z' fill='#391998' />
      <path
        d='M1.6962 11.8734C1.6962 12.3418 1.31649 12.7215 0.848101 12.7215C0.379708 12.7215 0 12.3418 0 11.8734C0 11.405 0.379708 11.0253 0.848101 11.0253C1.31649 11.0253 1.6962 11.405 1.6962 11.8734Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M17.8101 28.4114C17.8101 28.6456 17.6203 28.8354 17.3861 28.8354C17.1519 28.8354 16.962 28.6456 16.962 28.4114C16.962 28.1772 17.1519 27.9873 17.3861 27.9873C17.6203 27.9873 17.8101 28.1772 17.8101 28.4114Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M34.7722 13.5696C34.7722 14.038 34.3924 14.4177 33.924 14.4177C33.4557 14.4177 33.076 14.038 33.076 13.5696C33.076 13.1012 33.4557 12.7215 33.924 12.7215C34.3924 12.7215 34.7722 13.1012 34.7722 13.5696Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M17.8101 5.51266C17.8101 5.74685 17.6203 5.93671 17.3861 5.93671C17.1519 5.93671 16.962 5.74685 16.962 5.51266C16.962 5.27846 17.1519 5.08861 17.3861 5.08861C17.6203 5.08861 17.8101 5.27846 17.8101 5.51266Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M41.557 0.848101C41.557 1.31649 41.1773 1.6962 40.7089 1.6962C40.2405 1.6962 39.8608 1.31649 39.8608 0.848101C39.8608 0.379708 40.2405 0 40.7089 0C41.1773 0 41.557 0.379708 41.557 0.848101Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M56.8228 21.2025C56.8228 21.6709 56.4431 22.0506 55.9747 22.0506C55.5063 22.0506 55.1266 21.6709 55.1266 21.2025C55.1266 20.7341 55.5063 20.3544 55.9747 20.3544C56.4431 20.3544 56.8228 20.7341 56.8228 21.2025Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M48.3418 27.9873C48.3418 28.4557 47.9621 28.8354 47.4937 28.8354C47.0253 28.8354 46.6456 28.4557 46.6456 27.9873C46.6456 27.5189 47.0253 27.1392 47.4937 27.1392C47.9621 27.1392 48.3418 27.5189 48.3418 27.9873Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M58.519 10.6013C58.519 10.8355 58.3291 11.0253 58.0949 11.0253C57.8607 11.0253 57.6709 10.8355 57.6709 10.6013C57.6709 10.3671 57.8607 10.1772 58.0949 10.1772C58.3291 10.1772 58.519 10.3671 58.519 10.6013Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M79.7215 3.39241C79.7215 3.8608 79.3418 4.24051 78.8734 4.24051C78.405 4.24051 78.0253 3.8608 78.0253 3.39241C78.0253 2.92401 78.405 2.5443 78.8734 2.5443C79.3418 2.5443 79.7215 2.92401 79.7215 3.39241Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M90.7468 15.6899C90.7468 15.9241 90.557 16.1139 90.3228 16.1139C90.0886 16.1139 89.8987 15.9241 89.8987 15.6899C89.8987 15.4557 90.0886 15.2658 90.3228 15.2658C90.557 15.2658 90.7468 15.4557 90.7468 15.6899Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M79.7215 31.8038C79.7215 32.5064 79.152 33.0759 78.4494 33.0759C77.7468 33.0759 77.1772 32.5064 77.1772 31.8038C77.1772 31.1012 77.7468 30.5316 78.4494 30.5316C79.152 30.5316 79.7215 31.1012 79.7215 31.8038Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path d='M37.3779 14.9563H127.218V23.05H37.3779V14.9563Z' fill='#AA8DFF' />
      <path d='M37.3779 128.269H127.218V136.362H37.3779V128.269Z' fill='#AA8DFF' />
      <path d='M37.3779 23.05L29.2841 23.0503V31.144H37.3779V23.05Z' fill='#AA8DFF' />
      <path d='M135.312 23.0503L127.218 23.05L127.218 31.144H135.312V23.0503Z' fill='#AA8DFF' />
      <path d='M38.1876 120.984H30.0938V129.078H38.1876V120.984Z' fill='#AA8DFF' />
      <path d='M143 31.2959H134.906V121.946H143V31.2959Z' fill='#AA8DFF' />
      <path d='M30.0938 30.3345H22V120.984L30.0938 120.984L30.0938 30.3345Z' fill='#AA8DFF' />
      <path
        d='M70.6962 131.873C70.6962 132.342 70.3165 132.722 69.8481 132.722C69.3797 132.722 69 132.342 69 131.873C69 131.405 69.3797 131.025 69.8481 131.025C70.3165 131.025 70.6962 131.405 70.6962 131.873Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M86.8102 148.411C86.8102 148.646 86.6203 148.835 86.3861 148.835C86.1519 148.835 85.9621 148.646 85.9621 148.411C85.9621 148.177 86.1519 147.987 86.3861 147.987C86.6203 147.987 86.8102 148.177 86.8102 148.411Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M103.772 133.57C103.772 134.038 103.392 134.418 102.924 134.418C102.456 134.418 102.076 134.038 102.076 133.57C102.076 133.101 102.456 132.722 102.924 132.722C103.392 132.722 103.772 133.101 103.772 133.57Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M86.8102 125.513C86.8102 125.747 86.6203 125.937 86.3861 125.937C86.1519 125.937 85.9621 125.747 85.9621 125.513C85.9621 125.278 86.1519 125.089 86.3861 125.089C86.6203 125.089 86.8102 125.278 86.8102 125.513Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M110.557 120.848C110.557 121.317 110.177 121.696 109.709 121.696C109.24 121.696 108.861 121.317 108.861 120.848C108.861 120.38 109.24 120 109.709 120C110.177 120 110.557 120.38 110.557 120.848Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M125.823 141.203C125.823 141.671 125.443 142.051 124.975 142.051C124.506 142.051 124.127 141.671 124.127 141.203C124.127 140.734 124.506 140.354 124.975 140.354C125.443 140.354 125.823 140.734 125.823 141.203Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M117.342 147.987C117.342 148.456 116.962 148.835 116.494 148.835C116.025 148.835 115.646 148.456 115.646 147.987C115.646 147.519 116.025 147.139 116.494 147.139C116.962 147.139 117.342 147.519 117.342 147.987Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M127.519 130.601C127.519 130.835 127.329 131.025 127.095 131.025C126.861 131.025 126.671 130.835 126.671 130.601C126.671 130.367 126.861 130.177 127.095 130.177C127.329 130.177 127.519 130.367 127.519 130.601Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M148.722 123.392C148.722 123.861 148.342 124.241 147.873 124.241C147.405 124.241 147.025 123.861 147.025 123.392C147.025 122.924 147.405 122.544 147.873 122.544C148.342 122.544 148.722 122.924 148.722 123.392Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M159.747 135.69C159.747 135.924 159.557 136.114 159.323 136.114C159.089 136.114 158.899 135.924 158.899 135.69C158.899 135.456 159.089 135.266 159.323 135.266C159.557 135.266 159.747 135.456 159.747 135.69Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <path
        d='M148.722 151.804C148.722 152.506 148.152 153.076 147.449 153.076C146.747 153.076 146.177 152.506 146.177 151.804C146.177 151.101 146.747 150.532 147.449 150.532C148.152 150.532 148.722 151.101 148.722 151.804Z'
        fill='#FAFAFA'
        fillOpacity='0.5'
      />
      <defs>
        <linearGradient
          id='paint0_linear_698_4661'
          x1='79.8734'
          y1='153.076'
          x2='79.8734'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FAFAFA' />
          <stop offset='1' stopColor='#FAFAFA' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  )
}
